module.exports = __webpack_public_path__ + "media/images/country_flags/sg-29fc452feed17b6ad7e1b24b18d724ab.png";